var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckmarkCircledOutline = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2l.28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8l.25-.004C16.551 19.865 20 16.335 20 12l-.004-.25C19.865 7.449 16.335 4 12 4zm2.773 4.294c.35-.356.92-.405 1.327-.094.442.337.527.968.19 1.41l-4.57 6c-.189.245-.48.39-.79.39l-.13-.008c-.259-.032-.496-.165-.66-.372l-2.43-3.11-.071-.104c-.254-.427-.157-.987.246-1.301.436-.34 1.065-.261 1.405.175l1.63 2.11 3.78-5h-.01z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckmarkCircledOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkmarkCircledOutline.8cd07b64.svg";
export { ForwardRef as ReactComponent };